/**
 * 角色管理
 */
import React from "react";
import TreeAndTableLayout from "../../../../components/TreeAndTableLayout/TreeAndTableLayout";
import BaseComponent from "../../../../base/BaseComponent";
import RoleListToolBar from "./roleListToolBar/RoleListToolBar";
import RoleEditModal from "./roleEditModal/RoleEditModal";
import TableOperation from "./tableOperation/TableOperation";
import MenuAndPermissionSelect from "../menu/menuAndPermissionSelect/MenuAndPermissionSelect";
import "./roleList.css";
import {message} from "../../utils/sysManagementUtils";
import ContentWrap from "../../components/ContentWrap";
import TableToolBar from "../permission/tableToolBar/TableToolBar";

export default class RoleList extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            pageSize: 10,
            currentPage: 1,
            columns: [],
            count: 0,
            tableData: [],
            tableIsLoading: false,
            visible: false,
            treeData: [],
            nameOrCode: '',
            roleEditVisible: false,
            editRole: null,
            menuEditVisible: false
        };
    }

    componentDidMount() {
        this.roleRequest();
        this.getColumns();
    }

    render() {
        const {
            pageSize,
            currentPage,
            columns,
            count,
            tableData,
            tableIsLoading,
            roleEditVisible,
            editRole,
            menuEditVisible
        } = this.state;
        return (
            <ContentWrap>
                <TreeAndTableLayout
                    showTree={false}
                    pageSize={pageSize}
                    current={currentPage}
                    columns={columns}
                    count={count}
                    tableData={tableData}
                    tableIsLoading={tableIsLoading}
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}
                    ToolBar={
                        <RoleListToolBar
                            showRoleEdit={() => this.showRoleEdit()}
                            onSearchValueChange={nameOrCode => this.setState({nameOrCode})}
                            onSearch={this.onSearch}
                            searchValue={this.state.nameOrCode}
                        />
                    }
                />

                <RoleEditModal
                    visible={roleEditVisible}
                    data={editRole}
                    handleCancel={this.hideRoleEdit}
                    handleOk={this.submitRoleEdit}
                />

                <MenuAndPermissionSelect
                    visible={menuEditVisible}
                    data={editRole}
                    handleCancel={this.hideMenuEdit}
                    handleOk={this.submitMenuEdit}
                />
            </ContentWrap>
        );
    }

    /**
     * 当页码变换的回调
     * @param page
     * @param pageSize
     */
    onPageChange = (page, pageSize) => {
        this.setState({
            currentPage: page,
            pageSize: pageSize
        }, () => {
            this.roleRequest();
        });
    };

    /**
     * pageSize 变化的回调
     * @param current
     * @param size
     */
    onShowSizeChange = (current, size) => {
        this.setState({
            pageSize: size,
            currentPage: 1
        }, () => {
            this.roleRequest();
        });
    };
    onSearch = () => {
        this.setState({
            currentPage: 1,
            // searchValue:
        }, () => {
            this.roleRequest();
        });
    };
    hideMenuEdit = () => {
        this.setState({
            editRole: null,
            menuEditVisible: false
        });
    };

    showMenuEdit = editRole => {
        this.setState({
            editRole,
            menuEditVisible: true
        });
    };

    submitMenuEdit = ({menuCods, permissionCodes}) => {
        message.destroy();
        const {editRole} = this.state;
        const params = {
            roleCode: editRole.roleCode,
            menuCods,
            permissionCodes
        };
        if (!menuCods.length) {
            return message.error("请选择角色菜单");
        }
        this.rolepermissionMenuOperationRequest(params, res => {
            if (res) {
                this.hideMenuEdit();
                this.roleRequest();
                message.success("菜单绑定成功");
            }
        });
    };

    submitRoleEdit = role => {
        message.destroy();
        const {editRole} = this.state;
        if (!editRole) {
            this.roleAddRequest(role, res => {
                if (res) {
                    message.success("添加角色成功");
                }
                this.setState({
                    currentPage: 1
                }, () => {
                    this.hideRoleEdit();
                    this.roleRequest();
                });
            });
        } else {
            this.roleSaveRequest(role, res => {
                if (res) {
                    message.success("修改角色成功");
                }
                this.hideRoleEdit();
                this.roleRequest();
            });
        }

    };

    hideRoleEdit = () => {
        this.setState({
            roleEditVisible: false
        });
    };

    showRoleEdit = editRole => {
        this.setState({
            editRole,
            roleEditVisible: true
        });
    };

    roleRequest = () => {
        const {currentPage: page, pageSize: size, nameOrCode: nameOrCode} = this.state;
        this.setState({tableIsLoading: true});
        this.roleConditionQueryRequest({nameOrCode, page, size}, res => {
            const {count, data: tableData} = res;
            if (count !== 0 && count <= (page - 1) * size) {
                this.onPageChange(page - 1, size);
            } else {
                this.setState({
                    count,
                    tableData,
                    tableIsLoading: false
                });
            }

        });
    };

    getColumns = () => {
        const columns = [
            {
                title: "角色",
                dataIndex: "roleName",
                width: 210,
                ellipsis: true,
                render: (text, record) => {
                    return (<div onClick={() => this.showRoleEdit(record)}
                                 style={{
                                     color: "#0050B3",
                                     cursor: "pointer",
                                     width: "100%",
                                     overflow: "hidden",
                                     textOverflow: "ellipsis"
                                 }}>{record.roleName}</div>);
                }
            },
            {
                title: "编码",
                dataIndex: "roleCode",
                width: 210,
                ellipsis: true
            },
            {
                title: "描述",
                dataIndex: "roleDesc",
                width: 360,
                ellipsis: true
            },
            {
                title: "操作",
                width: 160,
                render: (text, record) => <TableOperation
                    data={record}
                    delRole={this.delRole}
                    showMenuEdit={this.showMenuEdit}
                />
            }
        ];
        this.setState({columns});
    };
    delRole = data => {
        this.delRoleRequest(data.roleCode, () => {
            this.roleRequest();
            message.success("角色删除成功");
        });
    };

/////////////////////////////////////////////
    roleConditionQueryRequest = ({nameOrCode, page, size}, callBack) => {
        this.request({
            url: "/cm-sites-sys/role/conditionQuery",
            contentType: "json",
            method: "post",
            body: {nameOrCode, page, size},
            callBack
        });
    };

    roleAddRequest = ({roleName, roleCode, roleDesc, roleState}, callBack) => {
        this.request({
            url: "/cm-sites-sys/role/add",
            method: "post",
            contentType: "json",
            body: {roleName, roleCode, roleDesc, roleState},
            callBack
        });
    };
    roleSaveRequest = ({roleName, roleCode, roleDesc, roleState}, callBack) => {
        this.request({
            url: "/cm-sites-sys/role/save",
            method: "post",
            contentType: "json",
            body: {roleName, roleCode, roleDesc, roleState},
            callBack
        });
    };

    delRoleRequest = (roleCode, callBack) => {
        this.request({
            url: "/cm-sites-sys/role/delRole",
            body: {roleCode},
            method: "get",
            callBack
        });
    };

    rolepermissionMenuOperationRequest = ({roleCode, menuCods, permissionCodes}, callBack) => {
        this.request({
            url: "/cm-sites-sys/role/permissionMenuOperation",
            body: {roleCode, menuCods, permissionCodes},
            method: "post",
            contentType: "json",
            callBack
        });
    };

}

